export default __webpack_public_path__ + "static/media/PF_01.89913e55.png";